var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletExt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F2F2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4062 13H11.5C11.2188 13 11 12.7812 11 12.5C11 12.25 11.2188 12 11.5 12H23.5C23.75 12 24 11.7812 24 11.5C24 10.6875 23.3125 10 22.5 10H11C9.875 10 9 10.9062 9 12V22C9 23.125 9.875 24 11 24H23.4062C24.2812 24 25 23.3438 25 22.5V14.5C25 13.6875 24.2812 13 23.4062 13ZM22 19.5C21.4375 19.5 21 19.0625 21 18.5C21 17.9688 21.4375 17.5 22 17.5C22.5312 17.5 23 17.9688 23 18.5C23 19.0625 22.5312 19.5 22 19.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletExt);
export default __webpack_public_path__ + "static/media/walletExt.0ed812dc.svg";
export { ForwardRef as ReactComponent };